export const CheckIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99997 15.586L6.70697 12.293L5.29297 13.707L9.99997 18.414L19.707 8.707L18.293 7.293L9.99997 15.586Z" fill="#47C09C" />
    </svg>
  );
};
